import { Button } from "@izicvs/ui";
import { t } from "@lingui/macro";
import { FileDashed, MagnifyingGlass } from "@phosphor-icons/react";

import { NewResumeButton } from "./new-resume";

// Shown when the account has no resumes at all.
export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center gap-y-5 rounded-2xl border border-dashed py-20 text-center">
    <div className="flex size-16 items-center justify-center rounded-full bg-secondary/60">
      <FileDashed size={32} className="opacity-70" />
    </div>
    <div className="space-y-1">
      <h2 className="text-lg font-semibold">{t`Create your first resume`}</h2>
      <p className="max-w-sm text-sm opacity-60">
        {t`Start from scratch, let the AI draft it, or import an existing one.`}
      </p>
    </div>
    <NewResumeButton />
  </div>
);

// Shown when a search returns nothing.
export const NoResults = ({ query, onClear }: { query: string; onClear: () => void }) => (
  <div className="flex flex-col items-center justify-center gap-y-4 rounded-2xl border border-dashed py-20 text-center">
    <div className="flex size-16 items-center justify-center rounded-full bg-secondary/60">
      <MagnifyingGlass size={32} className="opacity-70" />
    </div>
    <div className="space-y-1">
      <h2 className="text-lg font-semibold">{t`No resumes found`}</h2>
      <p className="max-w-sm text-sm opacity-60">
        {t`Nothing matches your search`}
        {query ? <span className="font-medium"> ({query})</span> : null}
      </p>
    </div>
    <Button variant="outline" size="sm" onClick={onClear}>
      {t`Clear search`}
    </Button>
  </div>
);
